import {Component, Input, OnInit} from '@angular/core';
import {HeaderInfo} from '../../model/header-info';
import { ConvertStatusCodeService } from 'src/shared/service/convert-status-code.service';

@Component({
  selector: 'dcu-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss']
})
export class HeaderInfoComponent implements OnInit {

  @Input() headerInfo: HeaderInfo = new HeaderInfo();

  constructor() {
  }

  ngOnInit() {
  }

  changeAvatar() {

  }

  public getStatusCssClass(status) {
    return ConvertStatusCodeService.getClassByCode(status);
  }
}
